import * as React from 'react';

const CardSubTitle: React.FunctionComponent = ({ children }) => {
    return <div className="card__subtitle">{children}</div>;
};

export { CardSubTitle };
